import { cn } from '@/utils/cn';

interface ShellProps {
  children: React.ReactNode;
  className?: string;
}

export function Shell({ children, className }: ShellProps) {
  return (
    <div className={cn('flex min-h-dvh flex-row bg-[#fafafa] font-sans antialiased text-gray-900', className)}>
      {children}
    </div>
  );
}
